import { render, staticRenderFns } from "./ModalMonitoramentoProduto.vue?vue&type=template&id=62a520f6&scoped=true&"
import script from "./ModalMonitoramentoProduto.vue?vue&type=script&lang=js&"
export * from "./ModalMonitoramentoProduto.vue?vue&type=script&lang=js&"
import style0 from "./ModalMonitoramentoProduto.vue?vue&type=style&index=0&id=62a520f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a520f6",
  null
  
)

export default component.exports